import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'Openpay-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

  goToHome() {
    window.location.href = 'https://www.tiendanube.com/login'
  }
}
